/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import store from 'src/redux/store';
import { actions as selectMenu } from 'src/redux/ducks/menu';
import { actions as selectOrgano } from 'src/redux/ducks/selectedCollegiateBody';
import { logOutAPI } from 'src/api/modules/auth';

function countdownFormatter(seconds) {
	const minutes = Math.floor(seconds / 60);
	const remainingSeconds = seconds % 60;
	return (
		minutes.toString().padStart(2, '0') +
		':' +
		remainingSeconds.toString().padStart(2, '0')
	);
}

export default function useCounterModal(inactivityDuration = 120, isAuthorized = false) {
	let resetMenu = {
		menu: {
			aside: {
				items: [
					{
						title: 'Inicio',
						icon: 'Home/Home.svg',
						slug: '/',
					},
				],
			},
		},
	};
	const dispatch = useDispatch();
	const [isExpired, setIsExpired] = useState(false);
	const [openModal, setOpenModal] = useState(false);
	const [leftSeconds, setLeftSeconds] = useState(null);
	const inactivityTimeoutRef = useRef(null);
	const countdownIntervalRef = useRef(null);

	const handleActivity = () => {
		clearTimeout(inactivityTimeoutRef.current);
		clearInterval(countdownIntervalRef.current);
		setOpenModal(false);
		setLeftSeconds(null);

		inactivityTimeoutRef.current = setTimeout(() => {
			setOpenModal(true);
			startCountdown(5 * 60);
		}, inactivityDuration * 60000);
	};

	const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

	const onLogOut = async () => {
		const token = store.getState()?.auth?.user?.accessToken;
		const filial = localStorage.getItem('type');
		console.log('filial:', JSON.stringify(filial));

		try {
			await logOutAPI.post({ token });
			dispatch(selectMenu.setMenu(resetMenu.menu));
			dispatch(selectOrgano.setOrgano(undefined));
			await sleep(1000);
		} catch (e) {
			console.error('Error en logout', e);
		}
	};

	const startCountdown = (duration) => {
		let secondsLeft = duration;
		countdownIntervalRef.current = setInterval(async () => {
			if (secondsLeft <= 0) {
				await onLogOut();
				clearInterval(countdownIntervalRef.current);
				setIsExpired(true);
				setOpenModal(false);
				setLeftSeconds(null);
				return;
			}
			setLeftSeconds(countdownFormatter(secondsLeft));
			secondsLeft--;
		}, 1000);
	};

	useEffect(() => {
		if (isAuthorized) {
			window.addEventListener('click', handleActivity);
			window.addEventListener('keypress', handleActivity);
			window.addEventListener('scroll', handleActivity);
			window.addEventListener('mousemove', handleActivity);

			handleActivity();

			return () => {
				clearTimeout(inactivityTimeoutRef.current);
				clearInterval(countdownIntervalRef.current);
				window.removeEventListener('click', handleActivity);
				window.removeEventListener('keypress', handleActivity);
				window.removeEventListener('scroll', handleActivity);
				window.removeEventListener('mousemove', handleActivity);
			};
		}
	}, [isAuthorized, inactivityDuration]);

	return { isExpired, openModal, leftSeconds };
}
